import { Injectable } from '@angular/core';
import { ShowInactiveService } from '../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../base/shared/syncfusion/adaptor-service.interface';
import { Observable, of } from 'rxjs';
import {
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfParkerTagDTO,
  ParkerTagClient,
  SortDirection,
} from '../../../base/models/models.swagger.generated';
import { ClientService } from '../../../base/services/client/client.service';

@Injectable({
  providedIn: 'root'
})
export class TagsAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(private parkerTagClient: ParkerTagClient,
              private clientService: ClientService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfParkerTagDTO> {
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }
    if (!sortBy) {
      sortBy = 'barcode,IdentificationCode';
    }
    if (this.clientService.selectedClient == null) {
      return of(new PagedResultDTOOfParkerTagDTO({items: [], totalNumberOfItems: 0}));
    }
    return this.parkerTagClient.searchTags(this.clientService.selectedClient.id, filters, skip, take, sortBy, sortDirection);
  }

  public addRecord(data: any): Observable<any> {
    return undefined;
  }

  public deleteRecord(id: number): Observable<any> {
    return undefined;
  }

  public updateRecord(data: any): Observable<any> {
    return undefined;
  }
}
